import { fromJS } from 'immutable';

import * as ActionType from '../actions/dialPadPusher';

const defaultState = fromJS({
  loaded: false,
  data: null,
});

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case ActionType.LOADED_DIAL_PAD_CHANNELS_SUCCESS:
      return state.merge({
        loaded: true,
        data: action.response.data,
      });

    default:
      return state;
  }
}
